import { Header, Page, Content } from '@backstage/core-components';
import { RefreshStatusLog } from './RefreshStatusLog';
import { useParams } from 'react-router-dom';

/**
 * RefreshStatusPage component
 * @constructor
 */
export const RefreshStatusPage = () => {
  const { runId } = useParams<{ runId: string }>();
  return (
    <Page themeId="tool">
      <Header title="Refresh Status" subtitle={`Run ID: ${runId}`} />
      <Content>
        <RefreshStatusLog runId={runId || null} />
      </Content>
    </Page>
  );
};
